import { render, staticRenderFns } from "./homeMenuHeader.vue?vue&type=template&id=9d23d048&"
import script from "./homeMenuHeader.vue?vue&type=script&lang=js&"
export * from "./homeMenuHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports